export default {"src":"/_next/static/media/Token24Icon.8596a227.svg","height":24,"width":24};